import React, { useEffect } from "react";
import Lenis from "lenis";

/**
 * Wraps the app with buttery-smooth momentum scrolling.
 * Programmatic scrollIntoView calls still work because Lenis
 * hooks into the native scroll behavior.
 */
export const SmoothScrollProvider = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.2,
    });

    // Attach to window for programmatic scrollTo (used by nav)
    window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return <>{children}</>;
};

export const smoothScrollTo = (target, opts = {}) => {
  const lenis = window.__lenis;
  if (!lenis) {
    if (typeof target === "string") {
      const el = document.querySelector(target);
      el?.scrollIntoView({ behavior: "smooth", block: "start" });
    } else if (target instanceof Element) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    return;
  }
  lenis.scrollTo(target, { duration: 1.4, ...opts });
};

export default SmoothScrollProvider;
